document.addEventListener('DOMContentLoaded', function () {
  const messagesNode = document.getElementById('cb-cart-messages');
  const messages = messagesNode ? JSON.parse(messagesNode.textContent) : {};
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.querySelectorAll('form[action$="/cart/add"]').forEach(form => {
    let pending = false;
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (pending) return;
      const button = form.querySelector('[type="submit"]');
      if (!button || button.disabled) return;
      pending = true;
      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      let errorBox = form.querySelector('[data-cart-error]');
      if (!errorBox) {
        errorBox = document.createElement('p');
        errorBox.setAttribute('data-cart-error', '');
        errorBox.setAttribute('role', 'alert');
        button.insertAdjacentElement('afterend', errorBox);
      }
      errorBox.textContent = '';
      errorBox.hidden = true;
      let added = false;
      try {
        // Preserve every app-provided quantity, bundle item and line property.
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || messages.error);
        added = true;
        const cartResponse = await fetch(root + 'cart.js');
        if (!cartResponse.ok) throw new Error(messages.refresh);
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
        if (window.openCartDrawer) window.openCartDrawer();
        else window.location.assign(root + 'cart');
      } catch (error) {
        // A network failure is not proof that the selected variant sold out.
        // Text insertion also keeps server/product text out of executable HTML.
        errorBox.textContent = added ? messages.refresh : (error.message || messages.error);
        if (!added && error instanceof TypeError) errorBox.textContent = messages.error;
        errorBox.hidden = false;
      } finally {
        pending = false;
        form.removeAttribute('aria-busy');
        button.disabled = false;
      }
    });
  });

  // Handle variant changes
  const variantSelectors = document.querySelectorAll('.variant-select');
  if (variantSelectors.length) {
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', function() {
        const form = this.closest('form');
        const selectedOptions = Array.from(variantSelectors).map(select => select.value);
        
        // Find the variant that matches all selected options
        const variant = window.product.variants.find(variant => {
          return JSON.stringify(variant.options) === JSON.stringify(selectedOptions);
        });

        if (variant) {
          // Update the hidden input
          form.querySelector('input[name="id"]').value = variant.id;
          
          // Update price
          const priceElement = document.querySelector('.current-price');
          if (priceElement) {
            priceElement.textContent = formatMoney(variant.price);
          }

          // Update availability
          const submitButton = form.querySelector('input[type="submit"]');
          if (submitButton) {
            submitButton.disabled = !variant.available;
            submitButton.value = variant.available ? 
              'Add to Cart' : 
              'Sold Out';
          }
        }
      });
    });
  }
});

// Helper function to format money
function formatMoney(cents) {
  // Get the store's money format from Shopify settings
  const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : "{{ shop.money_format }}";
  
  // Use Shopify's money formatting
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, moneyFormat);
  }
  
  // Fallback if Shopify.formatMoney is not available
  return (cents/100).toLocaleString(Shopify.locale || 'en-US', {
    style: 'currency',
    currency: Shopify.currency ? Shopify.currency.active : 'USD'
  });
}